const olga = global.olga || {}

import '../themes/default/style.less'

olga.config = {}

import Client from './Client'
import Tool from './Tool'
import Loader from './config/Loader'
import Tools from './Tools'

olga.Client = Client
olga.Tool = Tool
olga.config.Loader = Loader
olga.Tools = Tools

global.olga = olga

export default olga
